import React from 'react';
import './DestinationBestTime.css';

function DestinationBestTime({ destination }) {
  const getBestTimeInfo = (bestTime) => {
    if (bestTime === 'Year-round') {
      return {
        title: 'Year-Round Destination',
        description: 'This destination offers excellent wildlife viewing and experiences throughout the year, with each season bringing its own unique highlights.',
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        allActive: true
      };
    } else if (bestTime.includes('June - October')) {
      return {
        title: 'Dry Season (Best Time)',
        description: 'The dry season offers the best wildlife viewing as animals gather around water sources. Clear skies and comfortable temperatures make this the ideal time to visit.',
        months: ['Jun', 'Jul', 'Aug', 'Sep', 'Oct'],
        allActive: false
      };
    } else if (bestTime.includes('December - March')) {
      return {
        title: 'Calving Season (Peak Experience)',
        description: 'Witness the incredible wildebeest calving season when thousands of newborns arrive. This is also the peak of the migration, offering spectacular wildlife viewing.',
        months: ['Dec', 'Jan', 'Feb', 'Mar'],
        allActive: false
      };
    } else {
      return {
        title: 'Best Time to Visit',
        description: 'Plan your visit during these optimal months for the best wildlife viewing and weather conditions.',
        months: bestTime.split(', ').flatMap(period => {
          if (period.includes('-')) {
            const [start, end] = period.split(' - ');
            const monthMap = { 'January': 'Jan', 'February': 'Feb', 'March': 'Mar', 'April': 'Apr', 'May': 'May', 'June': 'Jun', 'July': 'Jul', 'August': 'Aug', 'September': 'Sep', 'October': 'Oct', 'November': 'Nov', 'December': 'Dec' };
            return [monthMap[start], monthMap[end]];
          }
          return [];
        }),
        allActive: false
      };
    }
  };

  const timeInfo = getBestTimeInfo(destination.bestTime);
  const allMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  return (
    <section className="destination-best-time-section">
      <div className="destination-best-time-container">
        <div className="best-time-header">
          <h2 className="best-time-title">{timeInfo.title}</h2>
          <p className="best-time-description">{timeInfo.description}</p>
        </div>
        
        <div className="months-calendar">
          {allMonths.map((month, index) => {
            const isActive = timeInfo.allActive || timeInfo.months.includes(month);
            return (
              <div 
                key={index} 
                className={`month-item ${isActive ? 'active' : ''}`}
              >
                <span className="month-name">{month}</span>
                {isActive && <span className="month-indicator"></span>}
              </div>
            );
          })}
        </div>

        <div className="best-time-details">
          <div className="time-detail-card">
            <h3>Weather</h3>
            <p>Generally pleasant with clear skies and comfortable temperatures during the recommended months.</p>
          </div>
          <div className="time-detail-card">
            <h3>Wildlife Viewing</h3>
            <p>Optimal conditions for spotting wildlife as animals are more active and visible during these periods.</p>
          </div>
          <div className="time-detail-card">
            <h3>Photography</h3>
            <p>Excellent lighting conditions and clear visibility make this the perfect time for photography.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DestinationBestTime;

